import React from "react";
import { motion } from "framer-motion";

import canovate from "../assests/canovate.jpg";
import corning from "../assests/corning.jpg";
import netconnect from "../assests/netconnect.png";
import ex from "../assests/essex.png";
import Dell_Logo from "../assests/Dell_Logo.png";
import datwyler from "../assests/datwyler.png";
import commscope from "../assests/Commscope_Logo.png";
import rittal from "../assests/rittal.png";
import schneider from "../assests/schneider.jpg";
import conteg from "../assests/conteg.png";
import hpe from "../assests/hpe.png";
import hawawei from "../assests/hawawei.png";
import alcatel from "../assests/alcatel.jpg";
import hp from "../assests/hp.png";
import juniper from "../assests/juniper.png";
import cisco from "../assests/cisco.png";
import Sunbird from "../assests/Sunbird.png";
import extron from "../assests/extron.png";
import axis from "../assests/axis.png";
import Bosch from "../assests/Bosch.png";
import hik from "../assests/hik.png";
import palo from "../assests/palo.png";

const partners = [
  { logo: canovate, url: "https://www.canovate.com" },
  { logo: corning, url: "https://www.corning.com" },
  { logo: netconnect, url: "https://www.commscope.com" },
  { logo: ex, url: "https://www.essex.com" },
  { logo: Dell_Logo, url: "https://www.dell.com" },
  { logo: datwyler, url: "https://www.datwyler.com" },
  { logo: commscope, url: "https://www.commscope.com" },
  { logo: rittal, url: "https://www.rittal.com" },
  { logo: schneider, url: "https://www.se.com" },
  { logo: conteg, url: "https://www.conteg.com" },
  { logo: hpe, url: "https://www.hpe.com" },
  { logo: hawawei, url: "https://www.huawei.com" },
  { logo: alcatel, url: "https://www.al-enterprise.com" },
  { logo: hp, url: "https://www.hp.com" },
  { logo: juniper, url: "https://www.juniper.net" },
  { logo: cisco, url: "https://www.cisco.com" },
  { logo: Sunbird, url: "https://www.sunbirddcim.com" },
  { logo: extron, url: "https://www.extron.com" },
  { logo: axis, url: "https://www.axis.com" },
  { logo: Bosch, url: "https://www.bosch.com" },
  { logo: hik, url: "https://www.hikvision.com" },
  { logo: palo, url: "https://www.paloaltonetworks.com" },
];

const Partnerships = () => {
  return (
    <div className="bg-gradient-to-br from-[#F5F5F5] to-[#FFFFFF] ">
      {/* العنوان */}
      <div className="bg-gradient-to-r from-[#201C59] to-indigo-700 text-white py-24 px-6 md:px-20 text-center mb-10 rounded-b-3xl shadow-lg">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-5xl font-bold mb-4"
        >
          Our Trusted Partners
        </motion.h1>
        <motion.p className="text-lg opacity-90">
          Brands that empower our success
        </motion.p>
      </div>

      {/* شبكة اللوجوز */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 px-8 mb-3">
        {partners.map((partner, index) => (
          <motion.a
            key={index}
            href={partner.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center bg-white rounded-2xl shadow-md p-4"
            whileHover={{
              scale: 1.1,
              rotateX: 8,
              rotateY: 8,
              boxShadow: "0px 15px 30px rgba(0,0,0,0.2)",
            }}
            transition={{ type: "spring", stiffness: 200, damping: 12 }}
          >
            <img
              src={partner.logo}
              alt={`partner-${index}`}
              className="w-28 h-28 object-contain mb-2"
            />
          </motion.a>
        ))}
      </div>
    </div>
  );
};

export default Partnerships;


// import React from "react";

// import canovate from "../assests/canovate.jpg";
// import corning from "../assests/corning.jpg";
// import netconnect from "../assests/netconnect.png";
// import ex from "../assests/essex.png";
// import Dell_Logo from "../assests/Dell_Logo.png";
// import datwyler from "../assests/datwyler.png";
// import commscope from "../assests/commscope.png";
// import rittal from "../assests/rittal.png";
// import schneider from "../assests/schneider.jpg";
// import conteg from "../assests/conteg.png";
// import hpe from "../assests/hpe.png";
// import hawawei from "../assests/hawawei.png";
// import alcatel from "../assests/alcatel.jpg";
// import hp from "../assests/hp.png";
// import juniper from "../assests/juniper.png";
// import cisco from "../assests/cisco.png";
// import Sunbird from "../assests/Sunbird.png";
// import extron from "../assests/extron.png";
// import axis from "../assests/axis.png";
// import Bosch from "../assests/Bosch.png";
// import hik from "../assests/hik.png";
// import palo from "../assests/palo.png";

// const partners = [
//   { logo: canovate, url: "https://www.canovate.com/" },
//   { logo: corning, url: "https://www.corning.com/" },
//   { logo: netconnect, url: "https://www.netconnect.com/" },
//   { logo: ex, url: "https://www.essex.com/" },
//   { logo: Dell_Logo, url: "https://www.dell.com/" },
//   { logo: datwyler, url: "https://www.datwyler.com/" },
//   { logo: commscope, url: "https://www.commscope.com/" },
//   { logo: rittal, url: "https://www.rittal.com/" },
//   { logo: schneider, url: "https://www.se.com/" },
//   { logo: conteg, url: "https://www.conteg.com/" },
//   { logo: hpe, url: "https://www.hpe.com/" },
//   { logo: hawawei, url: "https://www.huawei.com/" },
//   { logo: alcatel, url: "https://www.al-enterprise.com/" },
//   { logo: hp, url: "https://www.hp.com/" },
//   { logo: juniper, url: "https://www.juniper.net/" },
//   { logo: cisco, url: "https://www.cisco.com/" },
//   { logo: Sunbird, url: "https://www.sunbirddcim.com/" },
//   { logo: extron, url: "https://www.extron.com/" },
//   { logo: axis, url: "https://www.axis.com/" },
//   { logo: Bosch, url: "https://www.bosch.com/" },
//   { logo: hik, url: "https://www.hikvision.com/" },
//   { logo: palo, url: "https://www.paloaltonetworks.com/" },
// ];

// const Partnerships = () => {
//   return (
//     <div className="bg-gradient-to-br from-[#F5F5F5] to-[#6A75D7] py-16">
//       {/* العنوان */}
//       <div className="text-center mb-12">
//         <h2 className="text-4xl font-bold text-gray-800 mb-5">
//           Strategic Partnerships
//         </h2>
//       </div>

//       {/* شبكة اللوجوز */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 px-8">
//         {partners.map((partner, index) => (
//           <a
//             key={index}
//             href={partner.url}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="flex flex-col items-center justify-center bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300 p-4"
//           >
//             <img
//               src={partner.logo}
//               alt={`partner-${index}`}
//               className="w-28 h-28 object-contain mb-2"
//             />
//           </a>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Partnerships;





// import React from "react";

// import canovate from "../assests/canovate.jpg";
// import corning from "../assests/corning.jpg";
// import netconnect from "../assests/netconnect.png";
// import ex from "../assests/essex.png";
// import Dell_Logo from "../assests/Dell_Logo.png";
// import datwyler from "../assests/datwyler.png";
// import commscope from "../assests/commscope.png";
// import rittal from "../assests/rittal.png";
// import schneider from "../assests/schneider.jpg";
// import conteg from "../assests/conteg.png";
// import hpe from "../assests/hpe.png";
// import hawawei from "../assests/hawawei.png";
// import alcatel from "../assests/alcatel.jpg";
// import hp from "../assests/hp.png";
// import juniper from "../assests/juniper.png";
// import cisco from "../assests/cisco.png";
// import Sunbird from "../assests/Sunbird.png";
// import extron from "../assests/extron.png";
// import axis from "../assests/axis.png";
// import Bosch from "../assests/Bosch.png";
// import hik from "../assests/hik.png";
// import palo from "../assests/palo.png";
// import { motion } from "framer-motion";

// const partners = [
//   { logo: canovate },
//   { logo: corning },
//   { logo: netconnect },
//   { logo: ex },
//   { logo: Dell_Logo },
//   { logo: datwyler },
//   { logo: commscope },
//   { logo: rittal },
//   { logo: schneider },
//   { logo: conteg },
//   { logo: hpe },
//   { logo: hawawei },
//   { logo: alcatel },
//   { logo: hp },
//   { logo: juniper },
//   { logo: cisco },
//   { logo: Sunbird },
//   { logo: extron },
//   { logo: axis },
//   { logo: Bosch },
//   { logo: hik },
//   { logo: palo },
// ];

// const Partnerships = () => {
//   return (
//     <div className="bg-gradient-to-br from-[#F5F5F5] to-[#FFFFFF] ">
//       {/* العنوان */}
//       <div className="bg-gradient-to-r from-[#201C59] to-indigo-700 text-white py-24 px-6 md:px-20 text-center mb-10 rounded-b-3xl shadow-lg">
//         <motion.h1
//           initial={{ opacity: 0, y: -30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           className="text-5xl font-bold mb-4"
//         >
//           Our Trusted Partners
//         </motion.h1>
//         <motion.p className="text-lg opacity-90">
//           Brands that empower our success
//         </motion.p>
//       </div>



//       {/* شبكة اللوجوز */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 px-8">
//         {partners.map((partner, index) => (
//           <div
//             key={index}
//             className="flex flex-col items-center justify-center bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300 p-4"
//           >
//             <img
//               src={partner.logo}
//               alt={`partner-${index}`}
//               className="w-28 h-28 object-contain mb-2"
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Partnerships;